import { TagTypes } from '../../../Api/Types/tagTypes';
import type {
  ApproveImportRequest,
  RecomputeFa3ForExistingExpenseInvoicesRequest,
  RetryApproveImportJobsRequest,
} from '../Types/invoiceImport.types';

type RetryApproveInvalidatesTag =
  | TagTypes.InvoiceImportHistory
  | { type: TagTypes.Invoice; id: TagTypes.List }
  | { type: TagTypes.InvoiceImport; id: number };

type RecomputeFa3InvalidatesTag =
  | TagTypes.InvoiceImportHistory
  | { type: TagTypes.Invoice | TagTypes.ExpenseInvoice; id: TagTypes.List };

export const buildGetImportStatusRequest = (importJobId: number): string =>
  `/invoices/import/${importJobId}/status`;

export const buildApproveImportRequest = ({
  importJobId,
  userCorrections,
  approveOverride,
  approveOverrideReason,
}: ApproveImportRequest) => {
  const body: Record<string, unknown> = userCorrections ? { ...userCorrections } : {};

  if (approveOverride) {
    const normalizedReason = approveOverrideReason?.trim() ?? '';
    body.approveOverride = true;
    body.approveOverrideReason = normalizedReason;
    body.approveOverrideAuditContext = 'panel-admin:manual-review';
  }

  return {
    url: `/invoices/import/${importJobId}/approve`,
    method: 'POST' as const,
    body,
  };
};

export const buildRecomputeFa3ForExistingExpenseInvoicesRequest = (
  body: RecomputeFa3ForExistingExpenseInvoicesRequest
) => ({
  url: '/invoices/import/fa3/recompute',
  method: 'POST' as const,
  body,
});

export const buildRetryApproveImportJobsRequest = (body: RetryApproveImportJobsRequest) => ({
  url: '/invoices/import/fa3/retry-approve',
  method: 'POST' as const,
  body,
});

export const getRecomputeFa3InvalidatesTags = (): RecomputeFa3InvalidatesTag[] => [
  TagTypes.InvoiceImportHistory,
  { type: TagTypes.Invoice, id: TagTypes.List },
  { type: TagTypes.ExpenseInvoice, id: TagTypes.List },
];

export const getRetryApproveImportJobsInvalidatesTags = (
  importJobIds: number[]
): RetryApproveInvalidatesTag[] => {
  const uniqueImportJobIds = Array.from(new Set(importJobIds));

  return [
    TagTypes.InvoiceImportHistory,
    { type: TagTypes.Invoice, id: TagTypes.List },
    ...uniqueImportJobIds.map((importJobId) => ({
      type: TagTypes.InvoiceImport as const,
      id: importJobId,
    })),
  ];
};
